export default {
  "fabricData": {
  },
  "articleToSets": {
  },
  "setToArticles": {
    "GenericFabricSet" : [],
    "ContrastPoloFabricSet" : [],
    "ContrastFabricSet" : [],
    "PoloFabricSet" : [],
    "TestFabricSet" : [],
  }
}